/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunneledMcpServer,
  TunneledMcpServer$inboundSchema,
} from "./tunneledmcpserver.js";

/**
 * Result type for listing tunneled MCP servers
 */
export type ListTunneledMcpServersResult = {
  tunneledMcpServers: Array<TunneledMcpServer>;
};

/** @internal */
export const ListTunneledMcpServersResult$inboundSchema: z.ZodMiniType<
  ListTunneledMcpServersResult,
  unknown
> = z.pipe(
  z.object({
    tunneled_mcp_servers: z.array(TunneledMcpServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tunneled_mcp_servers": "tunneledMcpServers",
    });
  }),
);

export function listTunneledMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListTunneledMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTunneledMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTunneledMcpServersResult' from JSON`,
  );
}
